const comments = [
  {
    name: '触手迷小K',
    text: '终于找到专门的触手漫画网站了！之前到处找触手题材的漫画都很分散，这里汇集了这么多优质触手漫画，太棒了！',
    time: '2天前',
    likes: '326',
  },
  {
    name: '漫无止境',
    text: '下拉式阅读体验真的很流畅，不用翻页就能一直往下看，看触手漫画的效率直接翻倍。更新速度也很快，热门触手漫画基本同步。',
    time: '3天前',
    likes: '258',
  },
  {
    name: '二次元少年',
    text: '画质真的很高清，触手漫画的细节都能看得很清楚。种类也很丰富，从热血到温馨风格都有，每天都在追新番。',
    time: '4天前',
    likes: '201',
  },
  {
    name: '漫画控',
    text: '免费就能看触手漫画全集，还是高清的，这种良心网站必须推荐给更多触手漫画同好。不用注册直接看，体验满分！',
    time: '5天前',
    likes: '187',
  },
  {
    name: '深海读者',
    text: '触手漫画爱好者的天堂无疑了！收藏夹已加，每天都会上来看看有没有新的触手漫画更新。希望网站越做越好！',
    time: '6天前',
    likes: '153',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          读者心声
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画读者的真实评价与反馈
        </p>
        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-heading font-bold text-sm flex-shrink-0">
                  {comment.name[0]}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-foreground-400 flex-shrink-0">
                  <i className="ri-heart-line text-xs"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed pl-13">
                "{comment.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}